import GLOBAL from "../../../../setup/constants/global";

export const logTitle = (item) => {
  let title = "";
  let role = item?.requester_role?.name;
  let currentStatus = item?.current_status;
  let logType = item?.log_type;

  //   Generating title according to action string
  switch (item?.action) {
    // Ticket Assigned
    case "Maintenance ticket assigned":
      title = "Maintenance ticket assigned";
      break;

    // Default Case...
    default:
      title = item?.action;
  }

  return title;
};

export const statusColorGenerate = (status) => {
  switch (status) {
    case "New":
      return "font_blue";

    // return "font_blue";

    case "Rejected":
      return "font_red";

    case "Completed":
    case "Closed":
      return "font_green";

    default:
      return "font_yellow";
  }
};

export const orderStatusGenerate = (status) => {
  if (status === "Approved") {
    return {
      status: "Order Placed",
      button: "Place Order",
    };
  }
  if (status === "Order Placed") {
    return {
      status: "Parts Recieved",
      button: "Recieve Parts",
    };
  }
};

export const taskStatusGenerate = (status) => {
  switch (status) {
    case "technician_acceptance_pending":
    case "Pending":
      return { color: "font_yellow", text: "Pending Technician approval" };

    case "accepted_by_technician":
      return { color: "font_green", text: "Technician Accepted" };

    case "rejected_by_technician":
      return { color: "font_red", text: "Technician Rejected" };

    case "Completed":
      return { color: "font_blue", text: "Task Completed" };

    case "pm_approval_pending":
      return { color: "font_yellow", text: "PM Approval Pending" };

    case "Approved":
      return { color: "font_green", text: "Approved" };

    case "rejected_by_pm":
      return { color: "font_red", text: "Rejected By PM" };

    default:
      return {};
  }
};

const userActionPermission = (item, user) => {
  const logRequester = item?.requester?._id;
  const logRequesterRole = item?.requester_role?._id;
  const currentUser = user?._id;
  const currentUserRole = user.role_id;
  if (
    (logRequesterRole === currentUserRole && logRequester === currentUser) ||
    (currentUserRole === "670cda6398c7a474b944b36c" &&
      logRequesterRole === "63c10d5dffdea6cceb4af162")
  ) {
    return true;
  }
  return false;
};

// If Owner can accept maintenance request **
export const canOwnerAcceptReq = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (
    (action === "Maintenance ticket assigned" ||
      action === "Tenant has rescheduled the maintenance date") &&
    logType === "maintenance" &&
    currentStatus === "pending"
  ) {
    return true;
  }
  return false;
};

// If Owner can mark on the way
export const canOwnerMarkOnTheWay = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  const requesterRole = item?.requester_role?.name;
  if (currentStatus === "visit_scheduled") {
    return true;
  }
  return false;
};

// If Owner can mark check in
export const canOwnerMarkCheckIn = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  const requesterRole = item?.requester_role?.name;
  if (currentStatus === "technician_on_the_way") {
    return true;
  }
  return false;
};

// If Owner can mark no access
export const canOwnerMarkNoAccess = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  const requesterRole = item?.requester_role?.name;
  if (currentStatus === "technician_on_the_way") {
    return true;
  }
  return false;
};

// If Owner can add inspection report
export const canOwnerAddInspectionReport = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  const requesterRole = item?.requester_role?.name;
  if (
    currentStatus === "technician_on_the_location" ||
    currentStatus === "technician_on_the_location_again"
  ) {
    return true;
  }
  return false;
};

// If owner can create quotation **
export const canOwnerCreateQuotation = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (currentStatus === "inspection_report_added") {
    return true;
  }
  return false;
};

// If owner can place order **
export const canOwnerPlaceOrder = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;

  console.log(action, "[ACTI]");

  if (!userActionPermission(item, user)) {
    return false;
  }
  if (
    action === "Quoatation approved To Owner" ||
    action === "Owner received approval"
  ) {
    return true;
  }
  return false;
};

// If owner can place order **
export const canOwnerRecieveParts = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (currentStatus === "Order Placed") {
    return true;
  }
  return false;
};

// If owner can start maintenance **
export const canOwnerStartMaintenance = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;

  if (!userActionPermission(item, user)) {
    return false;
  }
  if (
    // ((action === "Owner accepted the maintenance request" ||
    //   action === "Maintenance is rejected by tenant") &&
    //   currentStatus === "visit_scheduled") ||
    // (action === "Quoatation approved To Owner" &&
    //   currentStatus === "Approved") ||
    // (action === "Owner received approval" &&
    //   currentStatus === "Approved" &&
    //   logType === "quoatation")

    currentStatus === "Parts Recieved" ||
    currentStatus === "inspection_report_added" ||
    action === "Quoatation approved To Owner"
    // ||
    // action === "Owner received approval"
  ) {
    return true;
  }
  return false;
};

// If owner can complete maintenance **
export const canOwnerCompleteMaintenance = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (action === "Maintenance is in progress" && currentStatus === "Ongoing") {
    return true;
  }
  return false;
};

// If FM can reassign ticket to other Managers **
export const canFmReassignManagers = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (
    action === "Maintenance ticket assigned" &&
    logType === "maintenance" &&
    currentStatus === "pending"
  ) {
    return true;
  }
  return false;
};

// If TPM can reassign ticket to other Managers **
export const canTPMReassignManagers = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (
    action === "Maintenance ticket is resassigned" &&
    logType === "maintenance" &&
    currentStatus === "pending"
  ) {
    return true;
  }
  return false;
};

// If FM can accept maintenance request **
export const canFMAcceptReq = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (
    action === "Maintenance ticket assigned" &&
    logType === "maintenance" &&
    currentStatus === "pending"
  ) {
    return true;
  }
  return false;
};

// If TPM can accept maintenance request **
export const canTPMAcceptReq = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (
    action === "Maintenance ticket is resassigned" &&
    logType === "maintenance" &&
    currentStatus === "pending"
  ) {
    return true;
  }
  return false;
};

// If FM can assign technician **
export const canFMAssignMT = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (
    currentStatus === "assign_mt_pending" ||
    currentStatus === "Parts Recieved"
  ) {
    return true;
  }
  return false;
};

// If technician can respond to maitenance request **
export const canMTRespondMaintenance = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (
    action === "Maintenance ticket assigned to Technician" &&
    currentStatus === "MT_acceptance_pending"
  ) {
    return true;
  }
  return false;
};

// If technician mark that he is on the way **
export const canMTMarkOnTheWay = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (currentStatus === "accepted_by_mt") {
    return true;
  }
  return false;
};

// If third party technician mark that he is on the way **
export const canTPTMarkOnTheWay = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (currentStatus === "accepted_by_mt") {
    return true;
  }
  return false;
};

// If technician can Check In **
export const canMTCheckIn = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  // return false;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (currentStatus === "technician_on_the_way") {
    return true;
  }
  return false;
};

// If third party technician can Check In **
export const canTPTCheckIn = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  // return false;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (currentStatus === "technician_on_the_way") {
    return true;
  }
  return false;
};

// If technician has No Access **
export const canMTNoAccess = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  // return false;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (currentStatus === "technician_on_the_way") {
    return true;
  }
  return false;
};

// If third party technician has No Access **
export const canTPTNoAccess = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  // return false;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (currentStatus === "technician_on_the_way") {
    return true;
  }
  return false;
};

// If TPT can start work or request for spare parts **
export const canTPTStrtWrkReq4Parts = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  // return false;
  if (
    currentStatus === "inspection_report_added" ||
    currentStatus === "parts_request_rejected" ||
    currentStatus == "technician_on_the_location_again"
  ) {
    return true;
  }
  return false;
};

// If MT can start work or request for spare parts **
export const canMTStrtWrkReq4Parts = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  // return false;
  if (
    currentStatus === "inspection_report_added" ||
    currentStatus === "parts_request_rejected" ||
    currentStatus == "technician_on_the_location_again"
  ) {
    return true;
  }
  return false;
};

// If FM can review spare parts requested **
export const canFMReviewSpareParts = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (currentStatus === "parts_requested") {
    return true;
  }
  return false;
};

// If FM can create quote **
export const canManagerCreateQuote = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (
    currentStatus === "parts_request_accepted" ||
    // action === "Quoatation reassigned to 3PM"
    action === "Quoatation reassigned to Third Party Manager"
  ) {
    return true;
  }
  return false;
};

// FM to update quatation
export const fmCanEditQuote = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }

  if (action === "Quoatation reassigned to Manager") {
    return true;
  }
};

// If PM can review spare parts quotaions **
export const canPMReviewQuotation = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (
    //action === "Quoatation assigned To PM"
    action === "Quoatation assigned To Property Manager"
  ) {
    return true;
  }
  return false;
};

// If PM can review spare parts quotaions **
export const canFMReviewQuotation = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (action === "Quoatation Request Assigned To Facility Manager") {
    return true;
  }
  return false;
};

// If MT can handover items **
export const canMTHandover = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (currentStatus === "work_in_progress") {
    return true;
  }
  return false;
};

// If TPT can handover items **
export const canTPTHandover = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (currentStatus === "work_in_progress") {
    return true;
  }
  return false;
};

// If MT can mark job complete **
export const canMTMarkJobComplete = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (
    currentStatus === "work_in_progress" ||
    currentStatus === "marked_items_to_handover"
    // || currentStatus === "technician_on_the_location"
  ) {
    return true;
  }
  return false;
};

// If TPT can mark job complete **
export const canTPTMarkJobComplete = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (
    currentStatus === "work_in_progress" ||
    currentStatus === "marked_items_to_handover"
    // || currentStatus === "technician_on_the_location"
  ) {
    return true;
  }
  return false;
};

// If FM can place order **
export const canFMPlaceOrder = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (
    action === "Manager received approval" ||
    action === "Quoatation Approved By Facility Manager"
  ) {
    return true;
  }
  return false;
};

// If technicians can start work
export const canTechnicianStartWork = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (currentStatus === "technician_on_the_location") {
    return true;
  }
  return false;
};

// If TPM can place order **
export const canTPMPlaceOrder = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }

  if (
    //action === "3PM received approval"
    action === "Third Party Manager received approval"
  ) {
    return true;
  }
  return false;
};

// If FM can recieve spare parts **
export const canFMRecieveSpareParts = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (currentStatus === "Order Placed") {
    return true;
  }
  return false;
};

// If TPM can assign TPT **
export const canTPMAssignTPT = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (
    currentStatus === "assign_mt_pending" ||
    currentStatus === "Parts Recieved"
  ) {
    return true;
  }
  return false;
};

// If TPT can respond to maintenance request sent by TPM **
export const canTPTRespondMaintenance = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (
    action === "Maintenance ticket assigned to Technician" &&
    currentStatus === "MT_acceptance_pending"
  ) {
    return true;
  }
  return false;
};

// If TPT can respond to maintenance request sent by TPM **
export const canOwnerActionOnQuotationT1 = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (action === "Quoatation approved To Owner" && logType === "quoatation") {
    return true;
  }
  return false;
};

// If MT/TPT can upload Inspection Report
export const canTechnicianUploadInspectionReport = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  const requesterRole = item?.requester_role?.name;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (currentStatus === "technician_on_the_location") {
    return true;
  }
  return false;
};

// Template
// export const functionTemplate = (item, user) => {
//   const action = item?.action;
//   const currentStatus = item?.current_status;
//   const logType = item?.log_type;
//   const requesterRole = item?.requester_role?.name;
//   if (!userActionPermission(item, user)) {
//     return false;
//   }
//   if (false) {
//     return true;
//   }
//   return false;
// };

// Template
export const functionTemplate = (item, user) => {
  const action = item?.action;
  const currentStatus = item?.current_status;
  const logType = item?.log_type;
  const requesterRole = item?.requester_role?.name;
  if (!userActionPermission(item, user)) {
    return false;
  }
  if (false) {
    return true;
  }
  return false;
};
